import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { getCurrentUser } from "../services/pocketbase";

const ImpossibleButton = () => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [roleAssigned, setRoleAssigned] = useState(false);
  const user = getCurrentUser();

  // Check zoom level on component mount and when window resizes
  useEffect(() => {
    const checkZoom = () => {
      // Calculate zoom level (approximation)
      const zoomLevel = Math.round(
        (window.outerWidth / window.innerWidth) * 100
      );
      setIsZoomed(zoomLevel >= 500);
    };

    // Initial check
    checkZoom();

    // Add event listener for resize
    window.addEventListener("resize", checkZoom);

    // Cleanup
    return () => {
      window.removeEventListener("resize", checkZoom);
    };
  }, []);

  const handleButtonClick = async () => {
    setShowMessage(true);

    // Only attempt to assign role if we have a Discord ID and role hasn't been assigned yet
    if (user.discord_id && !roleAssigned) {
      try {
        const response = await fetch("/api/discord/assign-role", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            discordId: user.discord_id,
            roleId: "1374458998186836088",
          }),
        });

        if (!response.ok) {
          console.error("Failed to assign role");
        } else {
          setRoleAssigned(true);
        }
      } catch (error) {
        console.error("Error assigning role");
      }
    } else if (!user.discord_id) {
      console.log("No Discord ID available for role assignment");
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 99999999999999,
        borderRadius: 1,
      }}
    >
      {isZoomed && (
        <Box
          onClick={handleButtonClick}
          sx={{
            width: "10px",
            height: "10px",
            backgroundColor: "background.paper",
            cursor: "pointer",
            borderRadius: 1,
          }}
        />
      )}

      {showMessage && (
        <Typography
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "background.paper",
            padding: 2,
            borderRadius: 1,
            boxShadow: 3,
            zIndex: 100000000,
          }}
        >
          Why are you like this?
        </Typography>
      )}
    </Box>
  );
};

export default ImpossibleButton;
